// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xAqC","placeholdersHeader":"styles_placeholdersHeader__1n65r","editorStyle":"styles_editorStyle__1MgSZ","placeholdersBox":"styles_placeholdersBox__2zI2Y"};